import { useIsAuthenticated } from "./use-is-authenticated";
import { useUserData } from "./use-user-data";

export const useAuth = () => {
  const [userData] = useUserData();
  const isAuthenticated = useIsAuthenticated();

  return {
    isAuthenticated,
    userData
  };
};
